import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-checkboxcellrenderer',
    templateUrl: './checkboxcellrenderer.component.html',
    styleUrls: ['./checkboxcellrenderer.component.scss'],
    standalone: false
})
export class CheckboxcellrendererComponent {
    checked: boolean = false;
    disabled: boolean = false;
    private params: any = {};
    hideCheckbox: boolean = false;
    labelText: string = '';
    showAltIcon: boolean = false;
    altIconClass: string = '';
    altIconLabel: string = '';

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.checked = !!params.value;
        if ('isDisabled' in params && typeof params.isDisabled === 'function') {
            this.disabled = params.isDisabled(params);
        }
        if ('hideCheckbox' in params && typeof params.hideCheckbox === 'function') {
            this.hideCheckbox = params.hideCheckbox(params);
        }
        if ('labelText' in params &&
              typeof this.params!.buttonName === 'function') {
              this.labelText = this.params.labelText(params!.data!.labelText);
        }
        if ('showAltIcon' in params && typeof params.showAltIcon === 'function') {
            this.showAltIcon = params.showAltIcon(params);
        }
        if ('altIconClass' in params) {
            this.altIconClass = params['altIconClass'] as string;
        }
        if ('altIconLabel' in params && typeof params.altIconLabel === 'function') {
            this.altIconLabel = params.altIconLabel(params);
        }
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        this.checked = !!params.value;
        if ('isDisabled' in params && typeof params.isDisabled === 'function') {
            this.disabled = params.isDisabled(params);
        }
        if ('labelText' in params &&
              typeof this.params!.buttonName === 'function') {
              this.labelText = this.params.labelText(params!.data!.labelText);
        }
        if ('showAltIcon' in params && typeof params.showAltIcon === 'function') {
            this.showAltIcon = params.showAltIcon(params);
        }
        if ('altIconClass' in params) {
            this.altIconClass = params['altIconClass'] as string;
        }
        if ('altIconLabel' in params && typeof params.altIconLabel === 'function') {
            this.altIconLabel = params.altIconLabel(params);
        }
        return true;
    }

    onChange(): void {
        if (this.disabled) return;
        const newValue = !this.checked;
        this.checked = newValue;
        if (this.params?.onMonitorChange) {
            this.params.onMonitorChange(this.params.data.authCode, newValue, this.params.data.lastName, this.params.data.requestDate);
        }
        if ('labelText' in this.params &&
              typeof this.params!.buttonName === 'function') {
              this.labelText = this.params.labelText(this.params!.data!.labelText);
        }
        if ('showAltIcon' in this.params && typeof this.params.showAltIcon === 'function') {
            this.showAltIcon = this.params.showAltIcon(this.params);
        }
        if ('altIconClass' in this.params) {
            this.altIconClass = this.params['altIconClass'] as string;
        }
        if ('altIconLabel' in this.params && typeof this.params.altIconLabel === 'function') {
            this.altIconLabel = this.params.altIconLabel(this.params);
        }
    }
}
